import { useToast } from '@medely/ui-kit';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNetworkRequest } from './useNetworkRequest';

export const useW2Interest = () => {
  const { axios } = useNetworkRequest();
  const queryClient = useQueryClient();
  const toast = useToast();
  const accountUrl = '/v3/professional/accounts';

  const { mutate: setW2Interest, isPending } = useMutation(
    (w2Interest: boolean) => {
      const payload = {
        professional: {
          w2_interest: w2Interest,
        },
      };
      return axios.put(accountUrl, payload);
    },
    {
      onSuccess: (_data, w2Interest) => {
        queryClient.invalidateQueries({ queryKey: ['GetProfessionalTodos'] });
        queryClient.invalidateQueries({ queryKey: ['GetCurrentUserForMarketsStep'] });
        if (w2Interest) {
          toast.success('Great! We’ll include W-2 shifts in your available opportunities.');
        }
      },
      onError: () => {
        toast.error('We were unable to update your preferences. Please try again.');
      },
    },
  );

  const { mutate: setLastSeenW2InterestAt } = useMutation(
    () => {
      const payload = {
        professional: {
          last_seen_w2_interest_at: new Date().toISOString(),
        },
      };
      return axios.put(accountUrl, payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['GetProfessionalTodos'] });
        queryClient.invalidateQueries({ queryKey: ['Me'] });
      },
    },
  );

  return {
    setW2Interest,
    setLastSeenW2InterestAt,
    isLoading: isPending,
  };
};
